module.exports = __webpack_public_path__ + "static/img/close.fa635bab.svg";